import Axios from "axios";
import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import moment from "moment";
import { postUpdateCDNUtil } from "../../../../helperFunctions/util";
import { applicationError } from "../../../../redux/actions/error";
import logger from "../../../../utils/logger";
import { db, storage } from "../../connection";
import { uploadImage } from "./website";

const imagePath = "content/images/";

/* ------- CREATE -------- */

// Create a new content for a group

// export async function fbCreateParentContent(
//   groupIds,
//   data,
//   imageFile,
//   isParentPost = true
// ) {
//   try {
//     if (!groupIds || !data || !imageFile || !isParentPost) {
//       throw new Error("Data, image file and isParentPost are required");
//     }

//     if (!Array.isArray(groupIds) || groupIds.length === 0) {
//       throw new Error(
//         "Group ids must be an array and must have at least one group id"
//       );
//     }

//     for (let groupId of groupIds) {
//       const result = await fbCreateContent(data, imageFile, isParentPost);
//       if (!result) {
//         throw new Error("There was error creating content for the group");
//       }
//     }

//     toast.success("Content created successfully");
//   } catch (error) {
//     let message = "There was error creating parent content, contact admin";
//     toast.error(message);
//     throw error;
//   }
// }

// Create image for content, called by create content
export function fbUploadContentImage(file, id, groupId) {
  return new Promise((resolve, reject) => {
    const storageRef = ref(storage);
    const folderRef = ref(storageRef, `${groupId}/${imagePath}${id}`);
    // storageRef.child(`${imagePath}${id}`);

    uploadBytes(folderRef, file)
      .then(async (snapshot) => {
        const downloadUrl = await getDownloadURL(snapshot.ref);
        resolve(downloadUrl, snapshot.metadata.fullPath);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function fbCheckChatChannelName(groupId, channelName, adminPostId) {
  return new Promise((resolve, reject) => {
    let collectionRef = collection(db, "chatChannel", groupId, "channels");
    const q = query(collectionRef, where("channelName", "==", channelName));
    getDocs(q)
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          if (adminPostId && querySnapshot.docs[0].id === adminPostId) {
            resolve();
          } else reject();
        } else {
          resolve();
        }
      })
      .catch((err) => {
        applicationError({
          message: "Error fetching chat-channel details",
          intensity: "high",
          err,
          errorCode: "firebase",
        });
      });
  });
}

// Read a single content based on id
export function fbGetContent(id, groupId, isParent = false) {
  return new Promise((resolve, reject) => {
    const docRef = isParent
      ? doc(db, "parentGroups", groupId, "events", id)
      : doc(db, "groupAdminPost", groupId, "posts", id);

    getDoc(docRef)
      .then((querySnapshot) => {
        resolve(querySnapshot.data());
      })
      .catch((err) => {
        let message = "There was an error fetching the document";
        applicationError({
          message,
          intensity: "low",
          err,
          errorCode: "firebase",
        });
        reject({ message });
      });
  });
}

export function fbGetChatChannel(groupId, adminPostId) {
  return new Promise((resolve, reject) => {
    getDoc(doc(db, "chatChannel", groupId, "channels", adminPostId))
      .then((querySnapshot) => {
        if (querySnapshot.exists()) {
          let data = querySnapshot.data() || {};
          resolve(data);
        } else {
          resolve();
        }
      })
      .catch((err) => {
        applicationError({
          message: "Error fetching chat-channel details",
          intensity: "high",
          err,
          errorCode: "firebase",
        });
      });
  });
}

function buildNotificationBody(
  tit,
  type,
  match,
  eventEpoch,
  volunteerRequests,
  ticketId,
) {
  if (type.toLowerCase() === "news" || type.toLowerCase() === "update") {
    return `${tit || type}${match ? ` for ${match}` : ""}. Read More.`;
  }

  let body = `${tit || type}${match ? ` for ${match}` : ""} is scheduled on ${_getDate(eventEpoch)}.`;

  let action = "";
  if (
    volunteerRequests &&
    Object.keys(volunteerRequests).length > 0 &&
    !ticketId
  ) {
    action = "Volunteer and RSVP.";
  } else if (ticketId) {
    action = "Buy Tickets and RSVP.";
  } else {
    action = "RSVP.";
  }

  return `${body} ${action}`.trim();
}

export async function _sendNotification(
  tit,
  type,
  volunteerRequests,
  ticketId,
  eventEpoch,
  match,
  gId,
  clubGroupId,
  ctnId,
  sendFanNotification,
) {
  var data = await fbGetGroupDetails(gId);
  var clubGroupData;
  if (clubGroupId) {
    clubGroupData = await fbGetGroupDetails(clubGroupId);
  }

  const title =
    type.toLowerCase() === "volunteer"
      ? `Volunteer with ${data.groupName}`
      : `${clubGroupData ? clubGroupData.groupName : data.groupName} ${type}`;

  const bodyString = buildNotificationBody(
    tit,
    type,
    match,
    eventEpoch,
    volunteerRequests,
    ticketId,
  );

  var payload = {
    gId: gId,
    image: "",
    gName: data.groupName,
    gCId: data.clubId,
    gLId: data.leagueId,
    timestamp: Date.now(),
    authorName: "",
    authorDocId: "",
    senderName: "",
    senderDocId: "",
    matchId: "",
    cName: "",
    cType: "",
    cId: "",
    pId: "",
    tit: title,
    bdy: bodyString,
    receiverDocId: "",
    topic: `${gId}_eventUpdates`,
    ctnId: ctnId,
    sendFanNotification: sendFanNotification || false,
    type: "admin_post",
  };

  Axios.post(
    `${import.meta.env.VITE_GCP_BASE_URL}/sendBulkNotification`,
    JSON.stringify(payload),
    {
      headers: {
        "content-type": "application/json",
      },
    },
  ).catch((err) => {
    logger.error("Error ", err);
  });
}

export async function sendBareNotification(
  tit,
  body,
  gId,
  clubGroupId,
  sendFanNotification,
  isWelcomeCard,
  sendMemberNotification,
) {
  var groupData = await fbGetGroupDetails(gId);
  var topic = `${gId}_eventUpdates`;
  var data = {
    uniqueId: `${gId}_welcome_notification`,
    gId: gId,
    image: "",
    gName: groupData.groupName,
    gCId: groupData.clubId,
    gLId: groupData.leagueId,
    timestamp: "",
    authorName: "",
    authorDocId: "",
    senderName: "",
    senderDocId: "",
    matchId: "",
    cName: "",
    cType: "",
    cId: "",
    pId: "",
    tit: tit,
    bdy: body,
    type: "admin_post",
    receiverDocId: "",
    topic: topic,
    ctnId: "",
    sendFanNotification: sendFanNotification,
    sendMemberNotification: sendMemberNotification,
    isWelcomeCard: isWelcomeCard,
  };
  if (sendFanNotification) {
    topic = `${gId}_general`;
    data.topic = topic;
  }
  Axios.post(
    `${import.meta.env.VITE_GCP_BASE_URL}/sendBulkNotification`,
    JSON.stringify(data),
    {
      headers: {
        "content-type": "application/json",
      },
    },
  ).catch((err) => {
    logger.error("Error ", err);
  });
}

export function _isToday(timestamp) {
  var date = new Date(timestamp * 1000);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();

  var today = new Date();
  var y = today.getFullYear();
  var m = today.getMonth() + 1;
  var d = today.getDate();
  if (y === year && d === day && m === month) {
    return true;
  } else {
    return false;
  }
}

export function _getDate(timestamp) {
  var date = new Date(timestamp * 1000);
  var d = date.getDate();
  var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  var week = days[date.getDay()];
  var month = monthNames[date.getMonth()];
  var res = `${week} ${month} ${d}`;
  return res;
}

export function fbGetGroupDetails(groupId) {
  return new Promise((resolve, reject) => {
    getDoc(doc(db, "group", groupId))
      .then((querySnapshot) => {
        resolve(querySnapshot.data());
      })
      .catch((err) => {
        let message = "There was an error fetching the group details";
        reject({ message });
      });
  });
}

export function getLocations(groupId) {
  return new Promise((resolve, reject) => {
    let locations = [];
    getDocs(collection(db, "group", groupId, "locations"))
      .then((querySnapshot) => {
        querySnapshot.docs.map((doc) => {
          let data = doc.data() || {};
          data.id = doc.id;

          locations.push(data);
        });
        resolve(locations);
      })
      .catch((err) => {
        let message = "There was an error fetching the locations";
        reject({ message });
      });
  });
}

export function getParentLocations(groupId) {
  return new Promise((resolve, reject) => {
    let locations = [];
    getDocs(collection(db, "parentGroups", groupId, "locations"))
      .then((querySnapshot) => {
        querySnapshot.docs.map((doc) => {
          let data = doc.data() || {};
          data.id = doc.id;

          locations.push(data);
        });
        resolve(locations);
      })
      .catch(() => {
        let message = "There was an error fetching the locations";
        reject({ message });
      });
  });
}

export function getParentLocationDetails(groupId, docId) {
  return new Promise((resolve, reject) => {
    getDoc(doc(db, "parentGroups", groupId, "locations", docId))
      .then((doc) => {
        let data = {};
        if (doc.exists()) {
          data = doc.data() || {};
          data.id = doc.id;
        }
        resolve(data);
      })
      .catch(() => {
        reject({ message: "There was an error fetching the locations" });
      });
  });
}

export function getLocationDetails(groupId, docId) {
  return new Promise((resolve, reject) => {
    getDoc(doc(db, "group", groupId, "locations", docId))
      .then((doc) => {
        let data = {};
        if (doc.exists()) {
          data = doc.data() || {};
          data.id = doc.id;
        }
        resolve(data);
      })
      .catch((err) => {
        let message = "There was an error fetching the locations";
        reject({ message });
      });
  });
}

export function fbSaveLocationDetails(data, groupId, docId) {
  return new Promise(async (res, rej) => {
    let docRef = doc(collection(db, "group", groupId, "locations"));
    if (docId) {
      docRef = doc(db, "group", groupId, "locations", docId);
    }

    if (data.locationImage && typeof data.locationImage === "object") {
      let downloadUrl = await uploadImage(
        data.locationImage,
        `${groupId}/locations/${docRef.id}/locationImage`,
        0,
      ).then(({ downloadUrl }) => {
        return downloadUrl;
      });
      data.locationImage = downloadUrl;
    }

    setDoc(docRef, data, {
      merge: true,
    })
      .then(() => {
        updateLocationInSections(data, groupId, docId).then(() => res());
        res();
      })
      .catch((e) => {
        rej(e);
      });
  });
}

export function fbSaveParentLocationDetails(data, groupId, docId) {
  return new Promise(async (res, rej) => {
    let docRef = doc(collection(db, "parentGroups", groupId, "locations"));
    if (docId) {
      docRef = doc(db, "parentGroups", groupId, "locations", docId);
    }

    if (data.locationImage && typeof data.locationImage === "object") {
      let downloadUrl = await uploadImage(
        data.locationImage,
        `${groupId}-parent/locations/${docRef.id}/locationImage`,
        0,
      ).then(({ downloadUrl }) => {
        return downloadUrl;
      });
      data.locationImage = downloadUrl;
    }

    setDoc(docRef, data, {
      merge: true,
    })
      .then(() => {
        updateLocationInSections(data, groupId, docId).then(() => res());
        res();
      })
      .catch((e) => {
        rej(e);
      });
  });
}

const updateLocationInSections = async (data, groupId, id) => {
  try {
    const websiteDocRef = doc(db, "website", groupId);

    const docSnap = await getDoc(websiteDocRef);

    if (!docSnap.exists()) {
      return;
    }

    const docData = docSnap.data();
    const sections = docData.sections || [];

    const eventLocationId = sections.eventLocations.findIndex(
      (item) => item.id === id,
    );
    const selectedLocationId = sections.selectedLocations.findIndex(
      (item) => item.id === id,
    );

    const updatedSections = { ...sections };

    if (eventLocationId !== -1) {
      updatedSections.eventLocations = updatedSections.eventLocations.map(
        (location) =>
          location.id === id ? { ...location, ...data } : location,
      );
    }

    if (selectedLocationId !== -1) {
      updatedSections.selectedLocations = updatedSections.selectedLocations.map(
        (location) =>
          location.id === id ? { ...location, ...data } : location,
      );
    }

    await updateDoc(websiteDocRef, {
      sections: updatedSections,
    });

    postUpdateCDNUtil(groupId);
  } catch (error) {
    logger.error("Error updating locations: ", error);
  }
};

export function fbDeleteLocation(groupId, docId) {
  let docRef = doc(db, "group", groupId, "locations", docId);
  return new Promise((res, rej) => {
    deleteDoc(docRef).then(res).catch(rej);
  });
}

export function fbDeleteParentLocation(groupId, docId) {
  let docRef = doc(db, "parentGroups", groupId, "locations", docId);
  return new Promise((res, rej) => {
    deleteDoc(docRef).then(res).catch(rej);
  });
}

export async function saveWelcomeCardDetails(data, groupId) {
  try {
    let docRef = doc(db, "group", groupId);

    const KEY_ORDER = {
      both: 0,
      members: 0,
      nonMembers: 1,
    };

    for (let key of Object.keys(data)) {
      let value = data[key];
      value.details = draftToHtml(
        convertToRaw(value.details.getCurrentContent()),
      );
      let image = value.image;
      if (image) {
        if (typeof image === "object") {
          await uploadImage(
            image,
            `${groupId}/welcomeCard/images/${KEY_ORDER[key]}`,
            0,
          );
        }
        value.image = true;
      } else {
        value.image = false;
      }
      if (value.button.url && !`${value.button.url}`.startsWith("https://")) {
        value.button.url = `https://${value.button.url}`;
      }

      // Ensure showCardUntilTimestamp is properly handled - keep null as null
      if (
        value.showCardUntilTimestamp === null ||
        value.showCardUntilTimestamp === undefined
      ) {
        value.showCardUntilTimestamp = null;
      }

      value.welcomeCardRepublishTimestamp = moment().unix();
    }
    let dataObj = JSON.parse(JSON.stringify(data));
    for (var key of Object.keys(dataObj)) {
      let value = dataObj[key];
      delete value.filledKeys;
      dataObj[key] = value;
    }

    await updateDoc(docRef, {
      welcomeCardDetails: dataObj,
    });
  } catch (error) {
    logger.error("Error saving welcome card details: ", error);
  }
}

// function generateId(length){
//   let result = "";
//   let characters =
//     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
//   let charactersLength = characters.length;
//   for (let i = 0; i < length; i++) {
//     result += characters.charAt(Math.floor(Math.random() * charactersLength));
//   }
//   return result;
// }

//DEPRECATED CODE

/* ------- UPDATE -------- */

// Update contents
// export function fbUpdateContentOld(
//   validatedData,
//   adminPostId,
//   imageFile,
//   channelChange,
//   newChannel,
//   deleteImage
// ) {
//   return new Promise(async (resolve, reject) => {
//     const batch = writeBatch(db);

//     // Clone to avoid mutation
//     const data = { ...validatedData };

//     const adminPostDoc = doc(
//       db,
//       "groupAdminPost",
//       data.groupId,
//       "posts",
//       adminPostId
//     );

//     let chatChannelImage;

//     // Handle image deletion
//     if (deleteImage) {
//       try {
//         await fbDeleteImage(adminPostId, data.groupId);
//         data.details.image = "";
//       } catch (err) {
//         logger.error("Failed to delete image:", err);
//       }
//     }

//     // Handle image upload
//     if (imageFile) {
//       try {
//         const downloadUrl = await fbUploadContentImage(
//           imageFile,
//           adminPostId,
//           data.groupId
//         );
//         data.details.image = downloadUrl;
//         chatChannelImage = downloadUrl;
//       } catch (err) {
//         const message =
//           "There was an error uploading the image, could not complete the operation, contact admin";
//         store.dispatch(
//           applicationError({
//             message,
//             intensity: "mid",
//             err,
//             errorCode: "firebase",
//           })
//         );
//         reject({ message });
//         return;
//       }
//     }

//     // Handle chat channel updates
//     const chatChannelDoc = doc(
//       db,
//       "chatChannel",
//       data.groupId,
//       "channels",
//       adminPostId
//     );

//     const hasChannel = !!data.chatChannel; // chatChannel is already a string

//     if (channelChange && hasChannel) {
//       // Channel name or dates changed
//       const channelData = {
//         channelName: data.chatChannel,
//         ...(chatChannelImage && { image: chatChannelImage }),
//       };
//       batch.set(chatChannelDoc, channelData, { merge: true });
//     } else if (newChannel && hasChannel) {
//       // New channel being created
//       chatChannelImage = chatChannelImage || data.details.image;
//       const chatChannelData = {
//         channelName: data.chatChannel,
//         image: chatChannelImage || "",
//       };
//       batch.set(chatChannelDoc, chatChannelData, { merge: true });
//     } else if (chatChannelImage && hasChannel) {
//       // Only image changed
//       batch.set(chatChannelDoc, { image: chatChannelImage }, { merge: true });
//     } else if (deleteImage && hasChannel) {
//       // Delete image from channel
//       batch.set(chatChannelDoc, { image: "" }, { merge: true });
//     }

//     // Prepare data for Firebase (chatChannel is already a string, no conversion needed)
//     const firebaseData = { ...data };
//     delete firebaseData.groupId;

//     // Handle additional locations migration
//     if (
//       Array.isArray(firebaseData.additionalLocations) &&
//       firebaseData.additionalLocations.length > 0
//     ) {
//       firebaseData.mapsData = deleteField();
//     }

//     batch.update(adminPostDoc, firebaseData);

//     batch
//       .commit()
//       .then(() => {
//         resolve({ ...firebaseData, id: adminPostDoc.id });
//       })
//       .catch((err) => {
//         const message =
//           "There was an error updating the content, could not complete the operation, contact admin";
//         store.dispatch(
//           applicationError({
//             message,
//             intensity: "mid",
//             err,
//             errorCode: "firebase",
//           })
//         );
//         reject({ message });
//       });
//   });
// }

// export async function fbCreateContent(data, imageFile, isParentPost = false) {
//   try {
//     let downloadUrl = "";
//     data.rsvp = {
//       attending: 0,
//       maybe: 0,
//       no: 0,
//     };
//     data.createdOn = parseInt(Date.now() / 1000);
//     const batch = writeBatch(db);
//     const adminPostDoc = doc(
//       collection(db, "groupAdminPost", data.groupId, "posts")
//     );

//     if (imageFile) {
//       // upload content image first
//       try {
//         downloadUrl = await fbUploadContentImage(
//           imageFile,
//           adminPostDoc.id,
//           data.groupId
//         );
//       } catch (err) {
//         let message =
//           "There was an error uploading image for the content, could not complete the operation, contact admin";
//         store.dispatch(
//           applicationError({
//             message,
//             intensity: "mid",
//             err,
//             errorCode: "firebase",
//           })
//         );
//         return;
//       }
//     }

//     if (data.chatChannel.channelName) {
//       // create chat channel for the content
//       const chatChannelDoc = doc(
//         db,
//         "chatChannel",
//         data.groupId,
//         "channels",
//         adminPostDoc.id
//       );

//       const chatChannelData = populateChatChannel(
//         data.chatChannel,
//         downloadUrl
//       );
//       batch.set(chatChannelDoc, { image: "", ...chatChannelData });
//     }

//     data.details.image = downloadUrl;
//     data.chatChannel = data.chatChannel.channelName;

//     if (isParentPost) {
//       data.isParentPost = true;
//     }

//     batch.set(adminPostDoc, data);

//     await batch.commit();

//     return { ...data, id: adminPostDoc.id };
//   } catch (error) {
//     let message = "There was error creating content, contact admin";
//     toast.error(message);
//     throw error;
//   }
// }

// function fbUpdateNotification2(data, oldNoti, gId, ctnId) {
//   let countrtyNameCodeMap = {};
//   Object.keys(countries).forEach((key) => {
//     countrtyNameCodeMap[key] = countries[key].name;
//   });
//   return new Promise(async (resolve, reject) => {
//     const batch = writeBatch(db);
//     // aList -> Notifications that are in data.notifications but not in oldNoti (new notifications).
//     // dList -> Notifications that were in oldNoti but not in data.notifications (removed notifications).
//     if (data.notifications !== null && oldNoti !== null) {
//       var aList = [];
//       data.notifications.forEach((f) => {
//         var ind = oldNoti.indexOf(f);
//         if (ind === -1) aList.push(f);
//         else oldNoti.splice(ind, 1);
//       });
//       var dList = oldNoti.filter((w) => !aList.includes(w));
//     }

//     const ref = doc(db, "contentNotifications", gId);

//     if (dList.length !== 0 || aList.length !== 0) {
//       var snap = await getDoc(ref);
//       // let notifications={}
//       var ts = [],
//         ns = [],
//         tys = [],
//         eDate = [],
//         mList = [],
//         ticketIds = [],
//         volunteerOption = [];
//       if (snap.exists()) {
//         ts = snap.data().time || [];
//         ns = snap.data().eventName || [];
//         tys = snap.data().type || [];
//         eDate = snap.data().epoch || [];
//         mList = snap.data().matches || [];
//         ticketIds =
//           snap.data().ticketIds ||
//           Array.from({ length: (ts || []).length }, (_) => "");
//         volunteerOption =
//           snap.data().volunteerOption ||
//           Array.from({ length: (ts || []).length }, (_) => "");
//         // notifications=snap.data().notifications || {};

//         dList.forEach((f) => {
//           var i = ts.indexOf(f);
//           if (i !== -1) {
//             ts.splice(i, 1);
//             ns.splice(i, 1);
//             tys.splice(i, 1);
//             eDate.splice(i, 1);
//             mList.splice(i, 1);
//           }
//         });
//       }

//       for (var j = 0; j < aList.length; j++) {
//         var today = _isToday(aList[j]);
//         var mt = data.matchName.trim().split("(")[0].trim();
//         let eventDate = moment
//           .unix(data.details.eventStartDate)
//           .set({ h: 0, m: 0, seconds: 59 })
//           .unix();

//         if (today) {
//           if (gId.includes("contents")) {
//             getGroups().then((groups) => {
//               let groupIds = [];
//               let clubGroup = groups.find((group) => group.isParent);
//               let clubGroupId = clubGroup.id;
//               for (var i = 0; i < data.groups.length; i++) {
//                 let param = data.groups[i];
//                 if (param === "global") {
//                   groupIds = [...groups.map((group) => group.id)];
//                 }
//                 groupIds = [
//                   ...groupIds,
//                   ...groups
//                     .filter(
//                       (group) =>
//                         (group.id === param ||
//                           continents[group.supportersRegion] === param ||
//                           countries[group.supportersCountry].name === param) &&
//                         !groupIds.includes(group.id)
//                     )
//                     .map((group) => group.id),
//                 ];
//               }
//               groupIds.forEach((gId) => {
//                 _sendNotification(
//                   data.title,
//                   data.type,
//                   data.volunteerRequests,
//                   data.ticketId,
//                   eventDate,
//                   mt,
//                   gId,
//                   clubGroupId,
//                   ctnId,
//                   data.showForFans
//                 );
//               });
//             });
//           } else {
//             _sendNotification(
//               data.title,
//               data.type,
//               data.volunteerRequests,
//               data.ticketId,
//               eventDate,
//               mt,
//               gId,
//               null,
//               ctnId,
//               data.showForFans
//             );
//           }
//         } else {
//           ts.push(aList[j]);
//           ns.push(data.title !== "" ? data.title : "-");
//           tys.push(data.type);
//           eDate.push(eventDate);
//           mList.push(mt);
//           ticketIds.push(data.ticketId);
//           volunteerOption.push(
//             Object.keys(data.volunteerRequests || {}).length > 0
//           );
//         }
//       }
//       batch.set(ref, {
//         eventName: ns,
//         time: ts,
//         type: tys,
//         epoch: eDate,
//         matches: mList,
//         ticketIds: ticketIds,
//         volunteerOption: volunteerOption,
//         // 'notifications': notifications
//       });

//       batch
//         .commit()
//         .then(() => {
//           resolve();
//         })
//         .catch((err) => {
//           let message =
//             "There was an error updating the notification content, could not complete the operation, contact admin";
//           store.dispatch(
//             applicationError({
//               message,
//               intensity: "mid",
//               err,
//               errorCode: "firebase",
//             })
//           );
//           reject({ message });
//         });
//     }
//   });
// }

// Create chat channel, called by create content
// function populateChatChannel(data, image) {
//   // 3 fields sent by content model, channelName, startDate, endDate
//   data = { ...data };
//   data.broadcast = false;
//   if (image) data.image = image;
//   data.description = "";
//   data.channelType = "public";
//   data.membersIds = [];
//   return data;
// }

/* ------- DELETE -------- */

// Delete content based on id
// export function fbDeleteContent(id, deleteImage, groupId) {
//   return new Promise(async (resolve, reject) => {
//     getDocs(query(collection(db, "groupAdminPost", id, "rsvp"), limit(1))).then(
//       async (querySnapshot) => {
//         if (querySnapshot.docs && querySnapshot.docs.length > 0) {
//           reject({
//             message: "This content has rsvps, cant delete the content",
//           });
//           return;
//         }

//         if (deleteImage) {
//           try {
//             await fbDeleteImage(id, groupId);
//           } catch (err) {
//             // let message =
//             //   "There was an error deleting the content image, could not complete the operation, contact admin";
//             // store.dispatch(
//             //   applicationError({
//             //     message,
//             //     intensity: "high",
//             //     err,
//             //     errorCode: "firebase"
//             //   })
//             // );
//             // reject({ message });
//             // return;
//           }
//         }
//         const docRef = doc(db, "groupAdminPost", groupId, "posts", id);
//         const batch = writeBatch(db);

//         batch.delete(docRef);
//         batch
//           .commit()
//           .then(() => {
//             postUpdateCDNUtil(groupId, "event");
//             resolve();
//           })
//           .catch((err) => {
//             let message =
//               "There was an error deleting the content completely, could not complete the operation, contact admin";
//             store.dispatch(
//               applicationError({
//                 message,
//                 intensity: "high",
//                 err,
//                 errorCode: "firebase",
//               })
//             );
//             reject({ message });
//           });
//       }
//     );
//   });
// }

// // Delete image for content, called by delete content
// function fbDeleteImage(id, groupId) {
//   return new Promise((resolve, reject) => {
//     const storageRef = ref(storage);
//     const imageRef = ref(storageRef, `${groupId}/content/images/${id}`);
//     deleteObject(imageRef).then(resolve).catch(reject);
//   });
// }
